import type { CriarSolicitacaoPayload } from '../types/arbitralDetailTypes';

export function montarMultipartSolicitacao(
  corpo: Omit<CriarSolicitacaoPayload, 'anexos'>,
  anexos: File[],
): FormData {
  const form = new FormData();
  form.append('tipo', corpo.tipo);
  if (corpo.payload) form.append('payload', JSON.stringify(corpo.payload));
  if (corpo.justificativa) form.append('justificativa', corpo.justificativa);
  if (corpo.alvoParteArbitralId) form.append('alvoParteArbitralId', corpo.alvoParteArbitralId);
  if (corpo.alvoArbitroProcessoId)
    form.append('alvoArbitroProcessoId', corpo.alvoArbitroProcessoId);
  for (const arquivo of anexos) form.append('anexos', arquivo);
  return form;
}
